<script lang="ts">
    import DoubleRangeSlider from "../../widgets/DoubleRangeSlider.svelte"

    export let min: number
    export let max: number
    export let unit: string
    export let label: string
    export let tolerance: number
    export let valueFormat: Function | undefined

    export let init
    export let rangeStart = init?.rangeStart
    export let rangeEnd = init?.rangeEnd
    export let reset
</script>

<div class="headline">{label}</div>
<DoubleRangeSlider
    min="{min}"
    max="{max}"
    unit="{unit}"
    bind:rangeStart="{rangeStart}"
    bind:rangeEnd="{rangeEnd}"
    bind:reset="{reset}"
    tolerance="{tolerance}"
    numberFormat="{valueFormat}"
/>

<style lang="less">
    @import "../../../css/variables.less";
    .headline {
        font-size: 1.2rem;
        @media (max-width: 1300px) {
            font-size: 1rem;
        }
    }
</style>
